export default __webpack_public_path__ + "static/media/blog-post-layout-02-img-09.cbb401ac.jpg";